<template>
    <v-container>
        <div class="mb-6">
            <v-card>
                <v-card-title>Edición del estado</v-card-title>
                <v-card-text class="pb-0">
                    <v-textarea label="Mensaje" rows="4" class="pt-0" dense v-model="estado.mensaje"></v-textarea>
                    <v-checkbox label="Ocupado" class="mt-0" dense v-model="estado.ocupado"></v-checkbox>
                </v-card-text>
                <v-card-actions class="pt-0" v-if="!$vuetify.breakpoint.xs">
                    <v-spacer></v-spacer>
                    <v-btn text  color="error" outlined @click="eliminarEstado" :disabled="!estado.id">Eliminar estado</v-btn>
                    <v-btn text  color="primary" outlined @click="guardarEstado">Guardar cambios</v-btn>
                </v-card-actions>
                <div v-if="$vuetify.breakpoint.xs" style="text-align: right">
                    <v-btn text  color="error" outlined @click="eliminarEstado" :disabled="!estado.id" class="mr-2 mb-2">Eliminar estado</v-btn><br>
                    <v-btn text  color="primary" outlined @click="guardarEstado" class="mr-2 mb-2">Guardar cambios</v-btn>
                </div>
            </v-card>
        </div>
        
        <div>
            <v-card :loading="loading">
                <v-card-title>Sesiones activas</v-card-title>
                <v-data-table :headers="headersListarSesiones" :items="sesionesUsuario" hide-default-footer id="tablaSesiones">
                    <template v-slot:item.last_activity="{ item }">
                    <span>{{ formatearFecha(item.last_activity) }}</span>
                    </template>
                    <template v-slot:item.eliminar="{ item }">
                        <v-icon v-if="item.id !== idSesionActual" @click="dialogEliminar=true, sesion=item">mdi-exit-to-app</v-icon>
                    </template>
                </v-data-table>
            </v-card>
        </div>
        <v-row justify="center">
            <v-dialog v-model="dialogEliminar" persistent width="500">
                <v-card>
                    <v-card-title class="headline">¡Atención!</v-card-title>
                    <v-card-text><div class="text-h6">¿Realmente quieres cerrar esta sesión?</div></v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogEliminar=false, sesion=null">Cancelar</v-btn>
                    <v-btn color="error" text @click="eliminarSesion()">Eliminar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import formatearFecha from "@/mixins/formatearFecha";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
    name: 'miPerfil',
    mixins: [formatearFecha],
    data: () => ({
        estado: {},

        loading: false,
        sesionesUsuario: [],
        idSesionActual: '',
        headersListarSesiones: [
            {
                text: 'Navegador',
                align: 'start',
                filterable: true,
                sortable: false,
                value: 'user_agent'
            },
            {
                text: 'IP',
                align: 'start',
                filterable: true,
                sortable: false,
                value: 'ip_address'
            },
            {
                text: 'Ultima vez activo',
                align: 'start',
                filterable: true,
                sortable: false,
                value: 'last_activity'
            },
            {
                text: 'Acciones',
                align: 'center',
                filterable: false,
                sortable: false,
                value: 'eliminar'
            }
        ],
        dialogEliminar: false,
        sesion: null,
    }),
    async created(){
        try {
            this.setLoading(true);
            await this.recuperarEstado();  
            await this.cargarSessionesUsuario();
            this.setLoading(false);
        } catch (error) {
            this.setLoading(false);
            this.setSnackbar({
                tipo: 'error',
                mensaje: 'Error. No se han podido recuperar los datos'
            });
        } 
    },
    methods: {
        ...mapActions(['setLoading', 'setSnackbar']),
        async recuperarEstado(){
            let respuesta = await axios.get(`/api/estadoUsuario?usuario=${this.authUser.id}`);
            this.estado = respuesta.data;
            this.estado.ocupado = this.estado.ocupado == 1? true : false;
        },
        async guardarEstado(){
            if(this.estado.ocupado == true || this.estado.mensaje){
                try {
                    this.setLoading(true);
                    this.estado.ocupado = this.estado.ocupado == true? 1 : 0; 
                    
                    if(this.estado.id){ //si el estado ya existe en la base de datos lo editamos
                        await axios.patch('/api/estadoUsuario', this.estado);
                    }else{ //si no existe lo creamos
                        this.estado.user_id = this.authUser.id;
                        await axios.post('/api/estadoUsuario', this.estado);
                    }
                    this.recuperarEstado();

                    this.setLoading(false);
                    this.setSnackbar({
                        tipo: 'success',
                        mensaje: 'Estado guardado correctamente'
                    });
                } catch (error) {
                    this.setLoading(false);
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'Error. No se ha podido guardar el estado'
                    });
                }   
            }else if(this.estado.id){
                this.eliminarEstado();
            }             
        },
        async eliminarEstado(){
            try {
                this.setLoading(true);
                await axios.delete(`/api/estadoUsuario/${this.estado.id}`);
                this.estado = {};
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'success',
                    mensaje: 'Estado eliminado correctamente'
                });
            } catch (error) {
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se ha podido eliminar el estado'
                });
            } 
        },
        async cargarSessionesUsuario() {

            this.loading = true;   
            try{
                let respuesta = await axios.get('/api/sesiones'); 
                this.sesionesUsuario = respuesta.data;
                
                respuesta = await axios.get('/api/sesiones?sesionActual=1'); 
                this.idSesionActual = respuesta.data;
                
                this.loading = false;   
            } catch (error) {
                this.loading = false;   
                this.setSnackbar({
                    tipo: "error",
                    mensaje: "Error. No se han podido recuperar los datos",
                });
            }

        },
        eliminarSesion(){
            axios.delete('/api/sesiones/'+ this.sesion.id).then(response => {
                this.cargarSessionesUsuario();
                this.setSnackbar({
                    tipo: 'success',
                    mensaje: 'Comentario eliminado correctamente'
                });
            }).catch(error => { 
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido eliminar el comentario'
                });
            });
            this.dialogEliminar = false;
            this.sesion = null;
        },
    },
    computed: {
        ...mapState('login', ['authUser'])
    },
}
</script>

<style>
    #tablaSesiones>.v-data-table__wrapper>table>tbody>tr>td:first-child { 
        padding-top: 10px !important;
        padding-bottom: 10px !important;
    }
    @media (max-width: 600px) {
        #tablaSesiones>.v-data-table__wrapper>table>tbody>tr>td:first-child { 
            height: auto;
        }
    }
</style>